/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1BannerBrandsQueryResponse,
  GetApiV1BannerBrands401,
  GetApiV1BannerBrands500,
} from "../../types/bannerRegistroController/GetApiV1BannerBrands.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1BannerBrands } from "../../clients/bannerRegistroController/getApiV1BannerBrands.ts";

export const getApiV1BannerBrandsQueryKey = () =>
  [{ url: "/api/v1/banner/brands" }] as const;

export type GetApiV1BannerBrandsQueryKey = ReturnType<
  typeof getApiV1BannerBrandsQueryKey
>;

export function getApiV1BannerBrandsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1BannerBrandsQueryKey();
  return queryOptions<
    GetApiV1BannerBrandsQueryResponse,
    ResponseErrorConfig<GetApiV1BannerBrands401 | GetApiV1BannerBrands500>,
    GetApiV1BannerBrandsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1BannerBrands({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as marcas ativas ordenadas por nome para uso como filtro na seleção de turmas. **(Requer Authorization para autenticação)**
 * @summary Listar marcas para seleção no banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/brands}
 */
export function useGetApiV1BannerBrands<
  TData = GetApiV1BannerBrandsQueryResponse,
  TQueryData = GetApiV1BannerBrandsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1BannerBrandsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1BannerBrandsQueryResponse,
        ResponseErrorConfig<GetApiV1BannerBrands401 | GetApiV1BannerBrands500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1BannerBrandsQueryKey();

  const query = useQuery(
    {
      ...getApiV1BannerBrandsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1BannerBrands401 | GetApiV1BannerBrands500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
